import { WorkingStatus } from "../../../../redux/api-model/employees/workContract";
import { TimetrackingRequestDto } from "../../../../redux/api-model/employees/workSchedule";

export enum ModuleEnum {
  DPF = "DPF",
  ABSENCE = "ABSENCE",
  TIMETRACKING = "TIMETRACKING",
  PAYROLL = "PAYROLL",
  DOCUMENTS = "DOCUMENTS",
  REPORTS = "REPORTS",
}

export interface SearchResultAvatarDto {
  uuid: string;
  contractId: string;
  firstName: string;
  lastName: string;
  position: string;
  imgLink: string;
  fileUrl?: string;
  documentId?: string;
  fileContentType?: string;
  fileName?: string;
  working?: WorkingStatus;
  workingTimetrackingRequest?: TimetrackingRequestDto;
  title: string | null;
}

export type SearchResultModuleGroupDto = {
  data: SearchResultAvatarDto[];
  module: ModuleEnum;
};
